/* eslint-disable camelcase */
export const REPORT_TYPES = {
  ADVERTISING_SPEND: 'Monthly Advertising Spend',
  CAMPAIGN_PERFORMANCE: 'Campaign Performance by Month',
  CALL_PERFORMANCE: 'Call Performance',
};
export const isClientReport = (value) => Object.hasOwn(REPORT_TYPES, value);
// Advertising reports draw on ad platforms; the call report draws on the phone
// system, so it carries no platform choice (and the backend must not require one).
export const needsPlatforms = (reportType) => reportType !== 'CALL_PERFORMANCE';
export const initialForm = (practiceId) => ({
  title: '',
  report_type: 'ADVERTISING_SPEND',
  practice_ids: practiceId ? [Number(practiceId)] : [],
  platforms: ['google_ads', 'meta'],
  period: 'previous_month',
  date_from: '',
  date_to: '',
  formats: ['PDF'],
  timezone: 'Europe/London',
  delivery_day: 3,
  time_of_day: '09:00',
  recipients: [],
  is_enabled: false,
});
export function buildPreviewPayload(form) {
  const { practice_ids, report_type, platforms, timezone, period, date_from, date_to } = form;
  return {
    practice_ids,
    report_type,
    ...(needsPlatforms(report_type) ? { platforms } : {}),
    timezone,
    ...(period === 'custom' ? { date_from, date_to } : { period }),
  };
}
export function buildSchedulePayload(form) {
  if (form.period === 'custom') throw new Error('Choose a calendar period for a repeating schedule.');
  const { title, delivery_day, time_of_day, recipients, formats, is_enabled } = form;
  return {
    ...buildPreviewPayload(form),
    title: title.trim(),
    delivery_day: Number(delivery_day),
    time_of_day,
    recipients: recipients.map((e) => e.trim()).filter(Boolean),
    formats,
    is_enabled,
  };
}
export function previewRows(snapshot) {
  return (snapshot?.practices || [])
    .flatMap((practice) =>
      (practice.rows || []).map((row) => ({
        ...row,
        practice: practice.name,
        id: JSON.stringify([practice.id, row.platform, row.account_id, row.campaign_id, row.month]),
      }))
    )
    .sort((a, b) => a.month.localeCompare(b.month) || a.id.localeCompare(b.id));
}
export function formatMetric(value, type, currency) {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return 'Not available';
  if (type === 'money' || type === 'cpc') {
    if (!currency) return `${Number(value).toLocaleString('en-GB', { maximumFractionDigits: 6 })} (Currency unknown)`;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
        ...(type === 'cpc' ? { minimumFractionDigits: 2 } : {}),
      }).format(Number(value));
    } catch {
      return `${value} (Currency unknown)`;
    }
  }
  return `${Number(value).toLocaleString('en-GB', { maximumFractionDigits: 4 })}${type === 'percent' ? '%' : ''}`;
}
export const WARNING_LABELS = {
  coverage_incomplete: 'Stored data does not cover the whole reporting period.',
  currency_unknown: 'Account currency is unavailable; totals cannot be combined.',
  timezone_unknown: 'Account timezone is unavailable.',
  account_disabled: 'Account is disabled; historical data is included.',
  no_accounts: 'No linked account for this location and platform.',
};
export const statusLabel = (status) =>
  ({
    pending: 'Waiting for generation',
    generating: 'Generating',
    generated: 'Ready to download (no email)',
    queued: 'Queued for email',
    sending: 'Sending — acceptance uncertain',
    sent: 'Email provider accepted',
    delivered: 'Delivery confirmed',
    delivery_failed: 'Delivery failed',
    generation_failed: 'Generation failed',
    blocked: 'Blocked: data or access unavailable',
    cancelled: 'Cancelled',
    ambiguous: 'Email acceptance uncertain — do not resend',
  }[status] || status);
export const isPolling = (status) => ['pending', 'generating', 'queued'].includes(status);
